import { icons, labelDefaultMediumStyles, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  /* The label line-height already leaves air under the heading, so the gap itself stays small. */
  gap: ${({ theme }) => theme.size.space['02']};
`

/**
 * Nothing happened and nothing is wrong, so this reads as a quiet aside rather than a banner
 * competing with the request itself.
 */
export const SkippedMessage = styled.p`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.subtle};
  margin: 0;
`

export const Title = styled.h3`
  ${labelDefaultMediumStyles}
  margin: 0;
  color: ${({ theme }) => theme.color.content.main};
`

export const Details = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: ${({ theme }) => theme.size.space['03']};
  column-gap: ${({ theme }) => theme.size.space['06']};
`

export const Label = styled.span`
  ${labelDefaultRegularStyles}
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.content.secondary};
`

export const Value = styled.span`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`

export const Link = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
  color: ${({ theme }) => theme.color.feedback.action.default};
  cursor: pointer;

  span {
    ${labelDefaultMediumStyles}
    font-weight: ${({ theme }) => theme.font.weight.medium};
  }

  svg {
    width: ${({ theme }) => theme.size.icon.small};
    height: ${({ theme }) => theme.size.icon.small};

    path {
      fill: ${({ theme }) => theme.color.feedback.action.default};
    }
  }
`

export const ChecksResult = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
`

export const ViewChecksReportButton = styled.button`
  ${labelDefaultMediumStyles}
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: fit-content;
  color: ${({ theme }) => theme.color.feedback.action.default};

  &:disabled {
    color: ${({ theme }) => theme.color.content.disabled};
    cursor: not-allowed;
  }
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
`

export const LoaderText = styled.span`
  ${labelDefaultMediumStyles}
`

export const InfoIcon = styled(icons.InfoSmall)`
  path {
    fill: ${({ theme }) => theme.color.feedback.danger.default};
  }
`
